// Modul zur Erfassung von einfachen Kosten
"use strict";

import CoreModels from "dias/core/models";
import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import controller from "./controller";
import template from "./template.jade";
import FoerderantragModels from "dias/foerderantrag/models";
import VertragModels from "dias/vertrag/models";

import builder from "dias/standard_foerdermodule/utils/builder";


const zuschuss_perioden = angular.module("dias.kosten_finanzierung.modul.zuschuss_perioden", [
  CoreModels.name,
  foerdermoduleRegistry.name,
  FoerderantragModels.name,
  VertragModels.name,
]);

zuschuss_perioden.config(/*@ngInject*/ FoerdermoduleRegistryProvider => {
  FoerdermoduleRegistryProvider.register("zuschuss_perioden", "modul-zuschuss-perioden");
})

  .directive("modulZuschussPerioden", builder.directive(template, controller));

export default zuschuss_perioden;
